/**
 * hooks/use-auth.ts
 *
 * TanStack Query mutations for register and login.
 * On success, stores JWT in localStorage and invalidates the couple query.
 */
import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { RegisterInput, LoginInput, AuthResponse, ApiSuccess } from '@just-us/shared'
import { apiFetch } from '../lib/api-client'
import { setToken, clearToken } from '../store/auth'

export const useRegister = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (input: RegisterInput) =>
      apiFetch<ApiSuccess<AuthResponse>>('/auth/register', {
        method: 'POST',
        body: JSON.stringify(input),
      }),
    onSuccess: ({ data }) => {
      setToken(data.token)
      queryClient.invalidateQueries({ queryKey: ['couple'] })
    },
  })
}

export const useLogin = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (input: LoginInput) =>
      apiFetch<ApiSuccess<AuthResponse>>('/auth/login', {
        method: 'POST',
        body: JSON.stringify(input),
      }),
    onSuccess: ({ data }) => {
      setToken(data.token)
      queryClient.invalidateQueries({ queryKey: ['couple'] })
    },
  })
}

export const useLogout = () => {
  const queryClient = useQueryClient()
  return () => {
    clearToken()
    queryClient.clear()
  }
}
